<template>
    <!-- 活动规则 -->
    <div v-if="bigWheelRewardList.length > 0"
        class="list-wrap activity-rules">
        <div class="container">
            <p v-if="bigWheelActivityType == bigWheel"
                style="width: 100%;text-align: center">
                <span style="font-size: 18px;color: #000000;text-align: center;font-weight: 600;">活动规则</span>
            </p>
            <div v-if="bigWheelActivityType == blindBox || tigerLottery"
                :class="tigerLottery ? 'tiger-prizes-title' : 'blindBox-prizes-title' "
                class="blindBox-info-title"
                :style="{'color': sectionThreeColor}">
                <div>活动规则</div>
            </div>
            <div class="ruleWrapper">
                <!-- pc端支持富文本编辑可能包含图片等 -->
                <div class="ruleImg" v-html="ruleDesci"></div>
            </div>
        </div>
        <div class="bottom-text"></div>
    </div>
</template>
<script>
import * as utils from '../common/global-variable.js';
export default {
  props: {
    bigWheelRewardList: Array,
    bigWheelActivityType: String,
    tigerLottery: Boolean,
    sectionThreeColor: String,
    ruleDesci: String
  },
  data() {
    return {
      bigWheel: utils.BigWheelConstants.BigWheelActivityType.bigTurnable,
      blindBox: utils.BigWheelConstants.BigWheelActivityType.blindBox,
    };
  },
};
</script>
<style lang="scss" scoped>
.list-wrap .container {
  background: #fff;
  border-radius: 10px;
  width: 96%;
  margin: 0 2%;
  padding: 20px 10px 20px;
  position: relative;
}
.activity-rules {
  display: block;
  width: 95%;
  margin-left: auto;
  margin-right: auto;
}
.tiger-prizes-title {
  div {
    &::before {
      background: linear-gradient(to right, transparent, #d7324c);
    }
    &::after {
      background: linear-gradient(to right, #d7324c, transparent);
    }
  }
}
.blindBox-prizes-title {
  color: #b27d13;
  div {
    &::before {
      background: linear-gradient(to right, transparent, #b27d13);
    }
    &::after {
      background: linear-gradient(to right, #b27d13, transparent);
    }
  }
}
.bottom-text {
  font-family: HYQiHei-EZS;
  font-size: 12px;
  color: #ffffff;
  text-align: center;
  font-weight: 400;
  padding: 10px;
}
.ruleWrapper {
  margin-top: 15px;
  font-size: 14px;
  display: flex;
  flex-wrap: wrap;
  color: #333333;
  word-break: break-all;
  .ruleImg /deep/ img {
    width: 100%;
    margin-right: 5px;
  }
  .ruleImg /deep/ pre {
    white-space:pre-wrap
  }
}
.blindBox-info-title {
  width: 100%;
  height: 20px;
  font-family: HYQiHei-FZS;
  font-size: 16px;
  font-weight: 400;
  position: relative;

  div {
    display: inline-block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    &::before {
      content: '';
      width: 40px;
      height: 3px;
      position: absolute;
      top: 50%;
      left: -60px;
    }

    &::after {
      content: '';
      width: 40px;
      height: 3px;
      position: absolute;
      top: 50%;
      right: -60px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/lucky-draw/components/activity-rules.vue